import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11f27798"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_input = _resolveComponent("app-input")!
  const _component_app_select = _resolveComponent("app-select")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Form, {
      as: "el-form",
      "validation-schema": _ctx.schema,
      onSubmit: _ctx.nextStep
    }, {
      default: _withCtx(() => [
        _createVNode(_component_app_input, {
          clearable: "",
          modelValue: _ctx.firstNameValue,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.firstNameValue) = $event)),
          onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.firstNameError = '')),
          "prop-error": _ctx.firstNameError,
          name: "firstName",
          label: _ctx.$localize('registration.first.name'),
          placeholder: _ctx.$localize('registration.first.name')
        }, {
          "label-append": _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["modelValue", "prop-error", "label", "placeholder"]),
        _createVNode(_component_app_input, {
          clearable: "",
          modelValue: _ctx.lastNameValue,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.lastNameValue) = $event)),
          onFocus: _cache[3] || (_cache[3] = ($event: any) => (_ctx.lastNameError = '')),
          "prop-error": _ctx.lastNameError,
          name: "lastName",
          label: _ctx.$localize('registration.last.name'),
          placeholder: _ctx.$localize('registration.last.name')
        }, {
          "label-append": _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["modelValue", "prop-error", "label", "placeholder"]),
        _createVNode(_component_app_select, {
          modelValue: _ctx.countriesValue,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.countriesValue) = $event)),
          onFocus: _cache[5] || (_cache[5] = ($event: any) => (_ctx.countriesError = '')),
          label: _ctx.$localize('registration.country'),
          placeholder: _ctx.$localize('registration.select.country'),
          name: "countries",
          options: _ctx.mainStore.countries,
          "prop-error": _ctx.countriesError,
          autocomplete: 'on',
          filterable: "",
          onVisibleChange: _ctx.triggerKeyboard,
          "data-is-search": "true"
        }, {
          "label-append": _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["modelValue", "label", "placeholder", "options", "prop-error", "onVisibleChange"]),
        (_ctx.countriesValue === 'US')
          ? (_openBlock(), _createBlock(_component_app_select, {
              key: 0,
              modelValue: _ctx.stateValue,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.stateValue) = $event)),
              onFocus: _cache[7] || (_cache[7] = ($event: any) => (_ctx.statesError = '')),
              label: _ctx.$localize('registration.state'),
              placeholder: _ctx.$localize('registration.select.state'),
              name: "state",
              options: _ctx.mainStore.states,
              "prop-error": _ctx.statesError,
              filterable: ""
            }, {
              "label-append": _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }, 8, ["modelValue", "label", "placeholder", "options", "prop-error"]))
          : _createCommentVNode("", true),
        (_ctx.countriesValue === 'CA')
          ? (_openBlock(), _createBlock(_component_app_select, {
              key: 1,
              modelValue: _ctx.provinceValue,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.provinceValue) = $event)),
              onFocus: _cache[9] || (_cache[9] = ($event: any) => (_ctx.provincesError = '')),
              label: "Province",
              placeholder: "Select province",
              name: "province",
              options: _ctx.mainStore.provinces,
              "prop-error": _ctx.provincesError,
              filterable: ""
            }, {
              "label-append": _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["modelValue", "options", "prop-error"]))
          : _createCommentVNode("", true),
        _createVNode(_component_app_button, {
          type: "primary",
          "native-type": "submit",
          class: "w-100 el-button-lg",
          round: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$localize('registration.name.button')), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["validation-schema", "onSubmit"])
  ]))
}